import axios from 'axios'
import config from '@/config'
import logger from '@/services/logger'
import delayer from '@/services/delayer'

export const api = axios.create({
  baseURL: config.api
})

if (process.env.NODE_ENV === 'development') {
  logger(api)
  delayer(api)
}

export default {

  meta: {
    get (lang) {
      return api.get('/sitemap', {
        headers: {
          'Accept-Language': lang
        }
      })
    }
  },

  pages: {
    getAll () {
      return api.get('/pages')
    },

    getDefault (url, name){

      if(!name)  return api.get(url);

      return api.get(url+'/'+name)
    },

    get (url) {
      return api.get('/pages/' + url)
    },

    getByType (name, limit, offset) {
      return api.get(name, {
        params: {
          limit,
          offset
        }
      });
    }
  },

  form: {
    send (data) {
      return api.post('/connects/create', data)
    }
  }

  // settings: {
  //   get () {
  //     return api.get('/constructors')
  //   },

  //   update (id, data) {
  //     return api.put(`/constructors/${id}`, data)
  //   }
  // },

  // products: {
  //   get () {
  //     return api.get('/products')
  //   },

  //   create (data) {
  //     return api.post('/products', data)
  //   },

  //   remove (id) {
  //     return api.delete(`/products/${id}`)
  //   },

  //   update (id, data) {
  //     return api.put(`/products/${id}`, data)
  //   }
  // },

  // certificates: {
  //   get () {
  //     return api.get('/certificates')
  //   },

  //   create (data) {
  //     return api.post('/certificates', data)
  //   },

  //   remove (id) {
  //     return api.delete(`/certificates/${id}`)
  //   },

  //   update (id, data) {
  //     return api.put(`/certificates/${id}`, data)
  //   }
  // },

  // schemes: {
  //   get () {
  //     return api.get('/principal-schemas')
  //   },

  //   create (data) {
  //     return api.post('/principal-schemas', data)
  //   },

  //   remove (id) {
  //     return api.delete(`/principal-schemas/${id}`)
  //   },

  //   update (id, data) {
  //     return api.put(`/principal-schemas/${id}`, data)
  //   }
  // },

  // proposals: {
  //   get () {
  //     return api.get('/commercial-proposals')
  //   },

  //   remove (id) {
  //     return api.delete(`/commercial-proposals/${id}`)
  //   }
  // },

  // files: {
  //   save (data) {
  //     return api.post(`${config.host}/api/file`, data)
  //   },

  //   convert (data) {
  //     return api.post(`${config.host}/api/process-file`, data)
  //   }
  // },

  // pdf: {
  //   render (data) {
  //     return api.post(`${config.host}/api/pdf`, data)
  //       .then((response) => {
  //         return response.data
  //       })
  //   }
  // },

  // user: {
  //   authorize (name, password) {
  //     return api.post(`/client/token`, {
  //       clientName: name,
  //       password
  //     })
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/services/api.js